import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { AppointmentStatus } from "models";

const component = "StatusListDashboard";

export const StatusListQueryKeys = {
  statuses: backendQueryKey<AppointmentStatus[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/app_statuses/list" })
};
